import React from 'react'
import PropTypes from 'prop-types'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { CategoriesRenderer } from 'LiveBoard/components/shared/CategoriesRenderer'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import ShareBoardContainer from 'LiveBoard/containers/ShareBoardContainer'
import { ShareBoard }  from 'LiveBoard/components/mobile/ShareBoard'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import CampaignEditorConfig from 'common/constants/CampaignEditorConfig'
import { scrollToElement } from 'LiveBoard/components/mobile/helper'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const MENU_ITEM_CLASS = 'menu-item'

class Menu extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  componentDidMount() {
    this.props.provideContainer(this.menuContainer)
    this.props.provideOutsideClickHandler(this.closeMenu)
  }

  componentWillUnmount() {
    this.props.provideContainer(null)
    this.props.provideOutsideClickHandler(null)
  }

  handleMenuClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  closeMenu = () => {
    this.setState({ isOpen: false })
  }

  handleCategorySelect = (categoryId) => {
    this.props.onCategorySelect(categoryId)
    this.setState({ isOpen: false })
    scrollToElement({elemClass: LIVE_BOARD_CLASSNAMES.items, addViewPort: true})
  }

  renderCategories() {
    const {
      categories: { data, categoryIds },
      selectedCategoryId, themeColorHex, showHomeCategory,
      getTranslation, board
    } = this.props
    const selectedCss = { color: themeColorHex }

    return (
      <div className='categories'>
        <div className='menu-title' style={{borderColor: themeColorHex}}>
          {getTranslation(TRANSLATION_VALUE_KEYS.contents)}
        </div>
        <CategoriesRenderer
          board={board}
          categories={data}
          categoryIds={categoryIds}
          selectedCategoryId={selectedCategoryId}
          onSelect={this.handleCategorySelect}
          categoryClass={MENU_ITEM_CLASS}
          selectedCategoryCSS={selectedCss}
          showHomeCategory={showHomeCategory}
          themeColorHex={themeColorHex} />
      </div>
    )
  }

  render() {
    const {
      config, themeColorHex, textColor, board, solidBackground,
      categories: {categoryIds}
    } = this.props
    const { isOpen } = this.state

    return (
      <div
        className={`menu-container ${isOpen ? 'open' : ''}`}
        ref={ref => this.menuContainer = ref} >
        <span
          className={`menu-btn icon-listview ${solidBackground || isOpen ? 'solid' : ''}`}
          onClick={this.handleMenuClick} />
        <div className='side-menu'>
          {config.cta.show && (
            <div className={MENU_ITEM_CLASS}>
              <span className='icon-message' />
              <CallToActionContainer
                config={{...config.cta}}
                area={CTA_AREAS.header}
                themeColorHex={themeColorHex} />
            </div>
          )}
          { includes(config.social, true) && (
            <div className={MENU_ITEM_CLASS}>
              <ShareBoardContainer
                component={ShareBoard}
                boardId={board.id}
                config={config.social}
                themeColorHex={themeColorHex}
                textColor={textColor} />
            </div>
          )}
          {!isEmpty(categoryIds) && this.renderCategories()}
        </div>
      </div>
    )
  }
}

Menu.propTypes = {
  categories: PropTypes.object,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onCategorySelect: PropTypes.func.isRequired,
  board: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  solidBackground: PropTypes.bool.isRequired,
  showHomeCategory: PropTypes.bool,
  provideContainer: PropTypes.func,
  provideOutsideClickHandler: PropTypes.func
}

export default withOutsideClickHandler(withTranslation(TRANSLATION_KEYS.mobileMenu)(Menu))